import React from 'react';
import { useTranslation } from 'react-i18next';

import { useMailStore } from './store/mail.store';
import { ChatHeader, ChatsList, MessengerBox, NoNewMessages } from './components';
import { PageHeadline } from '../../../components/atoms';

const ChatContent = () => {
  return (
    <div className="flex h-full flex-1 flex-col justify-start rounded-lg border-[2px] border-solid border-[#E1E9EF] bg-white overflow-hidden">
      <ChatHeader />
      <MessengerBox />
    </div>
  );
};

const MailRoom: React.FC = () => {
  const { selectedUser } = useMailStore();
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-6">
        <PageHeadline title={t('labels.lblContactUs')} />
      </div>

      <div className="mt-6 flex flex-1 flex-row gap-6">
        <div className="w-80 flex-shrink-0">
          <ChatsList />
        </div>

        <div className="flex flex-1">
          {selectedUser ? <ChatContent /> : <NoNewMessages />}
        </div>
      </div>
    </>
  );
};

export { MailRoom };
